<label for="typeahead-focus" class="input-title">Add Collaborators</label>
<ng-select
  class="custom"
  [items]="collaborators"
  [multiple]="true"
  [hideSelected]="true"
  [ngModelOptions]="{standalone: true}"
  bindLabel='name'
  [(ngModel)]="list"
  [virtualScroll]="true"
  (change)="getValue()"
  [searchable]='true'
  placeholder="start typing a name">
  <!-- this is selected -->
  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    <div class="ng-value" *ngFor="let item of items | slice:0:2">
      <span class="ng-value-label">
        {{item.name}} {{item.surname}}
      </span>
      <span class="icon" (click)="clear(item)" aria-hidden="true">×</span>
    </div>
    <div class="ng-value" *ngIf="items.length > 2">
      <span class="ng-value-label">{{items.length - 2}} more...</span>
    </div>
  </ng-template>
  <!-- this is option -->
  <ng-template ng-option-tmp let-item="item" >
    <div class="d-inline-flex w-100 align-items-center justify-content-between">
      <span class="ng-value-label d-flex">
        <img class="user-img" [src]="item.thumbnail | authImage | async">
        <div class="title d-flex flex-column">
          <span> {{item.name}} {{item.surname}}</span>
          <span> {{item.role}}</span>
        </div>
      </span>
      <i *ngIf="!item.disabled" class="ic-add" alt="Thumbnail image"></i>
      <i *ngIf="item.disabled" class="ic-check" alt="Thumbnail image"></i>
    </div>
  </ng-template>
</ng-select>
